import { render } from "./FileIcon.vue?vue&type=template&id=4f327d28&ts=true"
import script from "./FileIcon.vue?vue&type=script&lang=ts"
export * from "./FileIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__